import pickBy from 'lodash/pickBy';
import includes from 'lodash/includes';

import { sendRequest } from 'zoomforth_zfutils/xhr_tools.js';
import { triggerFirebaseEvent } from 'zoomforth_tools/firebase_events.js';

import pagesStore from 'zoomforth_zf/appglobals/pages.js';

import {
  getPageId
} from 'zoomforth_codesbane_editor/reducers/index.js';

import {
  makeSaveId,
  startSave,
  commitSave,
  failSave
} from 'zoomforth_shared_management/action_creators/saving.js';

import {
  notifyErrorMaybeLostData
} from './misc.js';


export const updatePageData = (pageData)=> 
  (dispatch)=> {
    dispatch({
      type: 'UPDATE_PAGE_FROM_SERVER',
      data: pageData
    });
    updatePageDataInLegacyStore(pageData);
  };


export const updatePageDataInLegacyStore = (pageData)=> {
  /*
    We need to update the collection so that the model representing
    the page is a new reference, rather than just updating the existing model.
    This is beacause otherwise react will not re-render components that
    depend on this page, since the reference will not have changed.
  
    Ideally, we would refactor the page details modal completely,
    but this will work for now.
  */
  const pageCollection = pagesStore.get();
  pageCollection.remove(pageData.id, {silent: true});
  pageCollection.add(pageData, {silent: true});
};


export const forcePageDataUpdateFromServer = ()=> 
  (dispatch, getState)=> {
    const pageId = getPageId(getState());
    sendRequest({
      url: `/v2/lenses/${pageId}`,
      method: 'GET',
      onSuccess: (data)=> {
        dispatch(updatePageData(data));
      },
      onError: ({ status, responseText })=> {
        dispatch(notifyErrorMaybeLostData(status, responseText));
      }
    });
  };


export const savePageMetaAttrs = (attrList)=>
  (dispatch, getState)=> {
    const state = getState();

    const pageId = getPageId(state);

    const pageModelData = pickBy(state.pageMeta, (v,i) => includes(attrList, i));
    
    const saveId = makeSaveId();
    dispatch(startSave('page_meta', saveId, 'Save page meta'));

    sendRequest({
      url: `/v2/lenses/${pageId}`,
      method: 'PATCH',
      params: pageModelData,
      onSuccess: (data)=> {
        triggerFirebaseEvent('lens-status-state-change', {
          lensId: pageId
        });
        dispatch(updatePageData(data));
        dispatch(commitSave(saveId));
      },
      onError: ({ status, responseText })=> {
        dispatch(failSave(saveId));
        dispatch(notifyErrorMaybeLostData(status, responseText));
      }
    });
  };


export const setLastEditedMeta = ({ lastEditedByUserId, lastEditedAt })=> {
  return {
    type: 'SET_LAST_EDITED_META_FOR_PAGE',
    lastEditedAt,
    lastEditedByUserId
  };
};
